export default __webpack_public_path__ + "static/media/11.7b22e9ca.jpg";